import { registerSW } from 'virtual:pwa-register'

const CHECK_INTERVAL_MS = 5 * 60 * 1000

let registration: ServiceWorkerRegistration | undefined

export function startVersionCheck() {
  if (import.meta.env.DEV) return

  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      updateSW(true)
    },
    onRegisteredSW(_url, swRegistration) {
      registration = swRegistration
      if (!swRegistration) return
      setInterval(() => {
        if (typeof document !== 'undefined' && document.hidden) return
        swRegistration.update()
      }, CHECK_INTERVAL_MS)
    }
  })
}

export function checkForAppUpdate() {
  if (registration) {
    registration.update()
  } else if (typeof window !== 'undefined') {
    window.location.reload()
  }
}
